import { type QuizQuestion, QuizQuestionType } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { Type } from '@warp-drive/core/types/symbols';

import { HiddenQuestionEditorComponent } from '../editors/question/hidden.gts';
import { ReportingEditorComponent } from '../editors/reporting/reporting.gts';
import type { QuestionManager } from '../types/question-manager';

export const HiddenQuestionManager: QuestionManager = {
  discriminator: (question: QuizQuestion) =>
    question.type === QuizQuestionType.Hidden,
  type: QuizQuestionType.Hidden,
  icon: 'ph:brackets-curly',
  editingIcon: 'ph:brackets-curly-fill',
  editingLabel: 'Data Value',
  label: 'Data Value',
  questionComponent: HiddenQuestionEditorComponent,
  scoringComponent: null,
  responseComponent: null,
  reportingComponent: ReportingEditorComponent,
  defaultData: {
    hidden: {
      [Type]: DataTypeQuiz.QuizQuestionHidden,
      defaultValue: '',
      query: '',
      showValue: false,
    },
    reporting: {
      [Type]: DataTypeQuiz.QuizReportingQuestion,
      groupName: '',
      questionName: '',
    },
  },
};
